import { z } from 'zod';

export type ComplectationOption = {
    id: number,
    option_id: number,
    option_name: string,
    option_symbolic_code: string,
    option_value_id: number,
    option_value_symbolic_code: string,
    option_value: string,
};

export type ComplectationOptionItemList = {
    name: string,
    values: Record<string, string>,
};

export const ComplectationOptionSchema = z.object({
    id: z.number(),
    option_id: z.number(),
    option_name: z.string(),
    option_symbolic_code: z.string(),
    option_value_id: z.number(),
    option_value_symbolic_code: z.string(),
    option_value: z.string(),
});
